/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpIcon16Regular = forwardRef('ArrowAUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.608 7.574a.75.75 0 0 1-1.06-1.061l3.927-3.928a2.156 2.156 0 0 1 3.05 0l3.927 3.928a.75.75 0 1 1-1.06 1.06L8.75 3.933v9.353a.75.75 0 0 1-1.5 0V3.932L3.608 7.574Z" })));
});
